module.exports = __webpack_public_path__ + "img/pic1.992e44ee.png";